/**
 * Basket page: quantity, removal and the voucher messages.
 *
 * Markup contract:
 *   <div class="checkout_main" x-data="basketPage">
 *     <select class="amounterer_select" data-amount-tracking="…" @change="changeAmount($el)">
 *     <button name="removeBtn" data-remove-from-cart-tracking="…" @click="removeItem($el)">
 *
 * Changing the amount and removing a position write the position's [am] field
 * and submit #basketForm, which reloads the page. The page shows the item list,
 * the vouchers and the totals at once and only the server knows all three, so
 * there is nothing a fragment could replace on its own.
 */
document.addEventListener('alpine:init', () => {
    /**
     * The "Zur Kasse" links (steps bar, mobile head, bottom line) sit in different Alpine scopes.
     *   <a class="zur-kasse-button" @click="$store.basketCheckout.go($event, $el)"
     *      :class="{ 'is-disabled': $store.basketCheckout.locked }" :aria-disabled="$store.basketCheckout.locked">
     *
     * An express payment that already sends the customer on (PayPal after the approval) locks
     * them: a click would start a second navigation and break the express redirect.
     */
    Alpine.store('basketCheckout', {
        locked: false,

        init() {
            // back from the bfcache the redirect is over
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    this.locked = false;
                }
            });
        },

        go(event, link) {
            if (this.locked) {
                event.preventDefault();
                return;
            }

            TrackingService.beginCheckoutTracking(link);
        },
    });

    Alpine.data('basketPage', () => ({
        init() {
            const message = this.$el.querySelector('.all_vouchers_wrapper .errors_wrapper, .all_vouchers_wrapper .crev_successaddvoucher');

            message?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        },

        changeAmount(select) {
            this.trackAmountChange(select);
            this.submitAmount(select, select.value);
        },

        removeItem(button) {
            TrackingService.trackRemoveFromCartButton(button);
            this.submitAmount(button, 0);
        },

        submitAmount(element, amount) {
            element.closest('.basket_contents_item').querySelector('[name$="[am]"]').value = amount;
            document.getElementById('basketForm').requestSubmit();
        },

        /** The difference is an add-to-cart or a remove-from-cart of that many pieces. */
        trackAmountChange(select) {
            const tracking = JSON.parse(select.dataset.amountTracking);
            const difference = Number(select.value) - tracking.amount;

            if (difference === 0) {
                return;
            }

            const product = { ...tracking.product, quantity: Math.abs(difference) };

            if (difference > 0) {
                TrackingService.addToCartItemTracking(product, tracking.currency, product.category);
                return;
            }

            TrackingService.removeItemFromCartTracking(product);
        },
    }));
});
